import React from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Trophy } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function CasiDiSuccesso() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Casi di successo", "Success stories", "Erfolgsgeschichten"), L("Casi di successo verificati di Recovers Crypto.", "Verified Recovers Crypto success stories.", "Verifizierte Erfolgsgeschichten von Recovers Crypto."));
  return (
    <div>
      <PageHero eyebrow={L("Casi di successo", "Success stories", "Erfolgsgeschichten")} title={L("Risultati documentati", "Documented results", "Dokumentierte Ergebnisse")}
        subtitle={L("Condivideremo casi di successo solo se verificati e con il consenso del cliente. Nessun importo o storia inventata.", "We will share success stories only if verified and with the client's consent. No invented amounts or stories.", "Wir teilen Erfolgsgeschichten nur, wenn sie verifiziert sind und mit Zustimmung des Kunden. Keine erfundenen Beträge oder Geschichten.")} />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="rounded-xl border border-dashed border-white/15 bg-navy-paper p-12 text-center" data-testid="success-empty">
          <Trophy className="mx-auto h-8 w-8 text-slate-600" />
          <p className="mt-3 text-sm text-slate-400">{L("Nessun caso di successo pubblicato al momento.", "No success stories published at the moment.", "Derzeit keine Erfolgsgeschichten veröffentlicht.")}</p>
        </div>
      </section>
    </div>
  );
}
